import React from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Drawer.scss";
import "../../assets/styles/Utils.scss";

import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";

import { Collapse, Drawer as MUI_Drawer } from "@mui/material";
import { Box, IconButton, CssBaseline, Divider } from "@mui/material";
import { List, ListItem, ListItemButton } from "@mui/material";
import { ListItemIcon, ListItemText } from "@mui/material";

import { ViewQuilt as ViewQuiltIcon } from "@mui/icons-material";
import { Equalizer as EqualizerIcon } from "@mui/icons-material/";
import { Portrait as PortraitIcon } from "@mui/icons-material/";
import { InfoRounded as InfoRoundedIcon } from "@mui/icons-material/";
import { Settings as SettingsIcon } from "@mui/icons-material/";
import { NotificationsActive as NotificationsActiveIcon } from "@mui/icons-material/";

import SaLogo from "../../image/sip_logo.png";
import GaLogo from "../../assets/images/ga/logo-ga-small.png";
import CricoLogo from "../../assets/images/crico/circo_logo.png";

import SaExpandedViewLogo from "../../image/sip_long_logo.png";
import GaExpandedViewLogo from "../../assets/images/ga/ga-logo-big.svg";
import CricoExpandedViewLogo from "../../assets/images/crico/crico_expanded_view_logo.png";

import { LocalLibrary as LocalLibraryIcon } from "@mui/icons-material/";
import { Tour as TourIcon } from "@mui/icons-material/";

import RightDrawer from "./RightDrawer";
import BellNotification from "../sendNotification/BellNotification";
import { LocalStorage, LoginUserDetails, Product } from "../../util/Utils";
import IdleTimeOutHandler from "../../service/idealTimeout";
import { ROLE, FA_USER_TYPE } from "../../routes/roles";
import ProfileBar from "./ProfileBar";
import { logout } from "../../auth/login/Auth";
import { THEME } from "../../util/LookupConst";
import FranchiseeUserAccessMenu from "./FranchiseeUserAccessMenu";
import FranchiseeLoginMenuList from "./FranchiseeLoginMenuList";

const drawerWidth = 278;

const createMenus = (menus: any, loginType: string) => {
  let drawerMenus: any[] = [];
  if (
    LoginUserDetails.getUserDetails().userType !== FA_USER_TYPE.TELE_CALLER &&
    LoginUserDetails.getUserDetails().userType !== FA_USER_TYPE.CI
  ) {
    if (loginType === ROLE.HO_ADMIN || loginType === ROLE.HO_USER) {
      drawerMenus.push({
        name: "Dashboard",
        icon: <ViewQuiltIcon />,
        subMenu: [],
        path: "/dashboardHO",
      });
    } else {
      drawerMenus.push(FranchiseeLoginMenuList.DASHBOARD);
      if (
        LoginUserDetails.getUserDetails().userType ===
        FA_USER_TYPE.CENTRE_MANAGER
      )
        drawerMenus = FranchiseeUserAccessMenu(menus);
    }
  }

  if (loginType === ROLE.HO_ADMIN || loginType === ROLE.HO_USER) {
    menus &&
      menus.forEach((menu: any) => {
        switch (menu.menuName) {
          case "MASTER": {
            drawerMenus.push({
              name: "Master",
              icon: <PortraitIcon />,
              subMenu: createSubMenus(menu.subMenu, loginType),
            });
            break;
          }
          case "STUDENT": {
            drawerMenus.push({
              name: "Student",
              icon: <LocalLibraryIcon />,
              subMenu: createSubMenus(menu.subMenu, loginType),
            });
            break;
          }
          case "PURCHASE": {
            drawerMenus.push({
              name: "Purchase",
              icon: <TourIcon />,
              subMenu: createSubMenus(menu.subMenu, loginType),
            });
            break;
          }
          case "REPORTS": {
            drawerMenus.push({
              name: "Reports",
              icon: <EqualizerIcon />,
              subMenu: createSubMenus(menu.subMenu, loginType),
            });
            break;
          }
          case "NOTIFICATIONS": {
            drawerMenus.push({
              name: "Notifications",
              icon: <NotificationsActiveIcon />,
              subMenu: createSubMenus(menu.subMenu, loginType),
            });
            break;
          }
          case "SETTINGS": {
            drawerMenus.push({
              name: "Settings",
              icon: <SettingsIcon />,
              subMenu: createSubMenus(menu.subMenu, loginType),
            });
            break;
          }
          case "FAQ": {
            drawerMenus.push({
              name: "Help & FAQ",
              icon: <InfoRoundedIcon />,
              subMenu: [],
            });
            break;
          }
        }
      });
  } else if (loginType === ROLE.FA_ADMIN) {
    drawerMenus.push({
      name: "Master",
      icon: <PortraitIcon />,
      subMenu: FranchiseeLoginMenuList.MASTER,
    });
    drawerMenus.push({
      name: "Student",
      icon: <LocalLibraryIcon />,
      subMenu:
        LoginUserDetails.getCountry() === "India"
          ? FranchiseeLoginMenuList.STUDENT
          : FranchiseeLoginMenuList.STUDENT_US,
    });
    if (LoginUserDetails.getCountry() === "India") {
      drawerMenus.push({
        name: "Purchase",
        icon: <TourIcon />,
        subMenu: FranchiseeLoginMenuList.PURCHASE,
      });
    }
    drawerMenus.push({
      name: "Reports",
      icon: <EqualizerIcon />,
      subMenu: FranchiseeLoginMenuList.REPORTS,
    });
    drawerMenus.push({
      name: "Notifications",
      icon: <NotificationsActiveIcon />,
      subMenu: FranchiseeLoginMenuList.NOTIFICATION,
    });
  } else if (
    loginType === ROLE.FA_USER &&
    LoginUserDetails.getUserDetails().userType !== FA_USER_TYPE.CENTRE_MANAGER
  ) {
    drawerMenus.push({
      name: "Student",
      icon: <LocalLibraryIcon />,
      subMenu: handleFaUserMenu(),
    });
  }
  drawerMenus.push({
    name: "Help & FAQ",
    icon: <InfoRoundedIcon />,
    subMenu: [],
  });
  return drawerMenus;
};

const handleFaUserMenu = () => {
  let faUserMenu: any = [];
  if (LoginUserDetails.getUserDetails().userType === FA_USER_TYPE.CI) {
    if (LoginUserDetails.getUserDetails()?.attendance === "Yes") {
      faUserMenu.push({ name: "Attendance", path: "/student-attendance" });
    }
    if (LoginUserDetails.getUserDetails()?.certificate === "Yes") {
      faUserMenu.push({
        name: "Certificate",
        path: "/certificate-booking-printing",
      });
    }
  } else if (
    LoginUserDetails.getUserDetails().userType === FA_USER_TYPE.TELE_CALLER
  ) {
    faUserMenu.push({ name: "Leads", path: "/student-lead-management" });
  } else if (
    LoginUserDetails.getUserDetails().userType === FA_USER_TYPE.CENTRE_MANAGER
  ) {
    faUserMenu.push(FranchiseeLoginMenuList.DASHBOARD);
  }
  return faUserMenu;
};

const createSubMenus = (subMenus: any, loginType: string) => {
  let drawerSubMenus: any[] = [];
  subMenus &&
    subMenus.forEach((subMenu: any) => {
      switch (subMenu.subMenuName) {
        case "USER_MASTER": {
          drawerSubMenus.push({
            name: "User Master",
            path: "/admin-user-master",
          });
          break;
        }
        case "USER_ROLE": {
          drawerSubMenus.push({ name: "User Role", path: "/user-role" });
          break;
        }
        case "ROLE_ACCESS": {
          drawerSubMenus.push({ name: "Role Access", path: "/role-access" });
          break;
        }
        case "FRANCHISEE_MASTER": {
          drawerSubMenus.push({
            name: "Franchisee Master",
            path: "/franchisee-master",
          });
          break;
        }
        case "ITEM_MASTER": {
          drawerSubMenus.push({ name: "Item Master", path: "/item-master" });
          break;
        }
        case "FRANCHISEE_GROUP": {
          drawerSubMenus.push({
            name: "Franchisee Group",
            path: "/franchisee-group",
          });
          break;
        }
        case "PROMO_CODE": {
          drawerSubMenus.push({ name: "Promo Code", path: "/promo-code" });
          break;
        }
        case "CERTIFICATE_REQUEST": {
          drawerSubMenus.push({
            name: "Certificate Request",
            path: "/certificate-request",
          });
          break;
        }
        case "PAYMENT_GATEWAY_SETTLEMENT": {
          drawerSubMenus.push({
            name: "Payment Gateway Settlement",
            path: "/payment-gateway-settlement",
          });
          break;
        }
        case "SMS_ORDER": {
          drawerSubMenus.push({ name: "SMS Order", path: "/sms-order" });
          break;
        }
        case "KIT_OUTSTANDING": {
          drawerSubMenus.push({
            name: "Kit Outstanding",
            path: "/kit-outstanding",
          });
          break;
        }
        case "CUSTOMER_DISCOUNT": {
          drawerSubMenus.push({
            name: "Customer Discount",
            path: "/customer-discount",
          });
          break;
        }
        case "INTERNAL_PURCHASE_ORDER": {
          drawerSubMenus.push({
            name: "Internal Purchase Order",
            path: "/internal-purchase-order",
          });
          break;
        }
        case "DISPATCH_PURCHASE_ORDER": {
          drawerSubMenus.push({
            name: "Dispatch Purchase Order",
            path: "/dispatch-purchase-order",
          });
          break;
        }
        case "PURCHASE_RETURN": {
          if (loginType === ROLE.FA_ADMIN) {
            drawerSubMenus.push({
              name: "Purchase Return",
              path: "/purchase-return",
            });
          } else {
            drawerSubMenus.push({
              name: "Purchase Return",
              path: "/ho-purchase-return",
            });
          }
          break;
        }
        case "PAYMENT": {
          drawerSubMenus.push({
            name: "Payment",
            path: "/payment",
          });
          break;
        }
        case "REDEEM_POINT_ORDER": {
          drawerSubMenus.push({
            name: "Redeem Point Order",
            path: "/redeem-point-order",
          });
          break;
        }
        case "DISPATCH_REDEEMED_PRODUCT": {
          drawerSubMenus.push({
            name: "Dispatch Redeemed Product",
            path: "/ho-dispatch-redeemed-product",
          });
          break;
        }
        case "MANAGE_REPORTS": {
          drawerSubMenus.push({
            name: "Manage Reports",
            path: "/ho-manage-reports",
          });
          break;
        }
        case "SEND_NOTIFICATION": {
          drawerSubMenus.push({
            name: "Send Notification",
            path: "/send-notification",
          });
          break;
        }
        case "FEEDBACK": {
          drawerSubMenus.push({ name: "Feedback", path: "/ho-feedback" });
          break;
        }
        case "ADMIN_SETTINGS": {
          drawerSubMenus.push({
            name: "Admin Settings",
            path: "/ho-admin-settings",
          });
          break;
        }
        case "FAQ": {
          drawerSubMenus.push({
            name: "Help & FAQ",
            icon: <InfoRoundedIcon />,
            subMenu: [],
          });
          break;
        }
      }
    });
  return drawerSubMenus;
};

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MUI_Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function MiniDrawer() {
  let drawerMenus;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const menus = LocalStorage.get("menus");
  const loginType = LocalStorage.get("loginType");
  const sidebarRef = React.useRef(null);
  const [drawerExpand, setDrawerExpand] = React.useState(false);
  const [openSubmenu, setOpenSubmenu] = React.useState(false);
  const [expandedIndex, setexpandedIndex] = React.useState(-1);
  const [expandedIndexSubmenu, setexpandedIndexSubmenu] = React.useState(-1);
  const [notificationDrawerOpen, setNotificationDrawerOpen] =
    React.useState(false);
  const [isActive, setIsActive] = React.useState(true);
  const [isLogout, setLogout] = React.useState(false);
  const sessionTimeout: string = process.env
    .REACT_APP_SESSION_TIMEOUT as string;

  const menusForUserByRole = (loginType: string) => {
    return createMenus(menus, loginType);
  };

  if (loginType) {
    drawerMenus = menusForUserByRole(loginType);
  }

  const handleNotificationDrawerOpen = () => {
    setNotificationDrawerOpen(!notificationDrawerOpen);
  };

  const handleNotificationDrawerClose = () => {
    setNotificationDrawerOpen(false);
  };

  const handleDrawerOpen = () => {
    setDrawerExpand(true);
  };

  const handleDrawerClose = () => {
    setDrawerExpand(false);
    setOpenSubmenu(false);
  };

  const handleSubmenuClick = (e: any, val: any, i: any) => {
    e.preventDefault();
    navigate(val.path);
    setexpandedIndexSubmenu(i);
    setDrawerExpand(!drawerExpand);
    setOpenSubmenu(!openSubmenu);
  };

  const handleClick = (index: any, subItem: any, path: any) => {
    if (subItem.length > 0) {
      setOpenSubmenu(true);

      if (drawerExpand === false) {
        setDrawerExpand(true);
      }
      setexpandedIndex(index);
    } else {
      setexpandedIndex(index);
      setexpandedIndexSubmenu(-1);
      setOpenSubmenu(false);

      if (drawerExpand === true) {
        setDrawerExpand(false);
      }
    }
    if (!subItem || subItem.length < 1) {
      path && navigate(path);
    }
  };

  React.useEffect(() => {
    // Add the event listener when the component mounts
    const handleDocumentClick = (event: any) => {
      if (
        sidebarRef.current &&
        event.target instanceof Node &&
        !(sidebarRef.current as unknown as HTMLElement).contains(
          event.target
        ) &&
        drawerExpand
      ) {
        handleDrawerClose();
      }
    };

    document.addEventListener("click", handleDocumentClick);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [drawerExpand]);

  return (
    <Box sx={{ paddingLeft: "70px" }}>
      <CssBaseline />
      {/* App bar */}
      <ProfileBar />
      <Drawer
        className="drawer"
        variant="permanent"
        open={drawerExpand}
        ref={sidebarRef}
      >
        <DrawerHeader className="draawer-background-color">
          {drawerExpand ? (
            <IconButton
              onClick={handleDrawerClose}
              style={{
                backgroundColor: "white",
                borderRadius: "6px",
                width: "100%",
              }}
            >
              {theme.direction === "rtl" ? (
                <img
                  src={
                    Product.ProductCode() === THEME.GA
                      ? GaExpandedViewLogo
                      : Product.ProductCode() === THEME.CRICO
                      ? CricoExpandedViewLogo
                      : SaExpandedViewLogo
                  }
                  alt="Logo"
                  style={{ height: "34px" }}
                />
              ) : (
                <img
                  src={
                    Product.ProductCode() === THEME.GA
                      ? GaExpandedViewLogo
                      : Product.ProductCode() === THEME.CRICO
                      ? CricoExpandedViewLogo
                      : SaExpandedViewLogo
                  }
                  alt="Logo"
                  style={{ height: "34px" }}
                />
              )}
            </IconButton>
          ) : (
            <IconButton
              onClick={handleDrawerClose}
              style={{
                backgroundColor: "white",
                borderRadius: "6px",
                width: "100%",
              }}
            >
              {theme.direction === "rtl" ? (
                <img
                  src={
                    Product.ProductCode() === THEME.GA
                      ? GaLogo
                      : Product.ProductCode() === THEME.CRICO
                      ? CricoLogo
                      : SaLogo
                  }
                  alt="Logo"
                  style={{ height: "34px" }}
                />
              ) : (
                <img
                  src={
                    Product.ProductCode() === THEME.GA
                      ? GaLogo
                      : Product.ProductCode() === THEME.CRICO
                      ? CricoLogo
                      : SaLogo
                  }
                  alt="Logo"
                  style={{ height: "34px" }}
                />
              )}
            </IconButton>
          )}
        </DrawerHeader>

        <Divider />

        <List className="draawer-background-color" style={{ height: "100vh" }}>
          {drawerMenus &&
            drawerMenus.map((ele, index) => {
              return (
                <ListItem key={index} disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    sx={{
                      justifyContent: drawerExpand ? "initial" : "center",
                      px: 2.5,
                    }}
                    className={
                      expandedIndex === index ? "active mainMenuColor" : ""
                    }
                    onClick={() => handleClick(index, ele.subMenu, ele.path)}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: drawerExpand ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <span className="menu-icon flex">{ele.icon}</span>
                    </ListItemIcon>
                    <ListItemText
                      className="center-start"
                      primary={<div className="center-start">{ele.name}</div>}
                      sx={{
                        opacity: drawerExpand ? 1 : 0,
                        color: "#fff",
                        height: "10px",
                      }}
                    />
                  </ListItemButton>
                  {ele.subMenu.length > 0 &&
                    openSubmenu &&
                    expandedIndex === index &&
                    ele.subMenu?.map((val: any, index: number) => (
                      <Collapse
                        key={index}
                        in={openSubmenu}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          <ListItemButton
                            sx={{ pl: 4 }}
                            className={
                              expandedIndexSubmenu === index
                                ? "active mainMenuColor"
                                : ""
                            }
                            onClick={(e: any) =>
                              handleSubmenuClick(e, val, index)
                            }
                          >
                            <a
                              style={{
                                display: "table-cell",
                                textDecoration: "none",
                              }}
                              href={window.location.pathname}
                            >
                              <ListItemText primary={val && val.name} />
                            </a>
                          </ListItemButton>
                        </List>
                      </Collapse>
                    ))}
                </ListItem>
              );
            })}
        </List>
      </Drawer>

      <Outlet />

      <RightDrawer
        open={notificationDrawerOpen}
        onClose={handleNotificationDrawerClose}
        title={t("notification")}
        content={<BellNotification />}
      />

      <IdleTimeOutHandler
        onActive={() => {
          setIsActive(true);
        }}
        onIdle={() => {
          setIsActive(false);
        }}
        onLogout={() => {
          setLogout(true);
          logout();
        }}
        timeOutInterval={parseInt(sessionTimeout) * 60000}
      />
    </Box>
  );
}

export default MiniDrawer;
